import { render, staticRenderFns } from "./mem_block_left.vue?vue&type=template&id=2d11782e&scoped=true&"
import script from "./mem_block_left.vue?vue&type=script&lang=js&"
export * from "./mem_block_left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d11782e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d11782e')) {
      api.createRecord('2d11782e', component.options)
    } else {
      api.reload('2d11782e', component.options)
    }
    module.hot.accept("./mem_block_left.vue?vue&type=template&id=2d11782e&scoped=true&", function () {
      api.rerender('2d11782e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/sides/mem_block_left.vue"
export default component.exports